import { useEffect, useState } from 'react'

import { getTechRegions } from '../api'
import { useAppDispatch } from '@sales-center/common'

export function useGetTechRegionsOnMount() {
  const [loading, setLoading] = useState(true)

  const dispatch = useAppDispatch()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        await dispatch(getTechRegions(undefined))
      } catch {
      } finally {
        if (mounted) setLoading(false)
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return loading
}
